export class NotificationDriverDto {
    id: number;
    city: string | null;
    email: string;
    name: string;
    last_name: string;
    dni: string;
    cif: string | null;
    nie: string | null;
    rating: string;
    budget: number | null;
    is_compatible: boolean;
    other_transports: number[];

    constructor(data: Partial<NotificationDriverDto> = {}) {
        this.id = data.id ?? 0;
        this.city = data.city ?? null;
        this.email = data.email ?? '';
        this.name = data.name ?? '';
        this.last_name = data.last_name ?? '';
        this.dni = data.dni ?? '';
        this.cif = data.cif ?? null;
        this.nie = data.nie ?? null;
        this.rating = data.rating ?? '0.00';
        this.budget = data.budget ?? null;
        this.is_compatible = data.is_compatible ?? false;
        this.other_transports = data.other_transports ?? [];
    }

    static fromJson(json: Record<string, unknown>): NotificationDriverDto {
        return new NotificationDriverDto(json as Partial<NotificationDriverDto>);
    }

    toJson(): Record<string, unknown> {
        return {
            id: this.id,
            city: this.city,
            email: this.email,
            name: this.name,
            last_name: this.last_name,
            dni: this.dni,
            cif: this.cif,
            nie: this.nie,
            rating: this.rating,
            budget: this.budget,
            is_compatible: this.is_compatible,
            other_transports: this.other_transports,
            // Campos derivados para el datagrid
            driver: `${this.name} ${this.last_name}`.trim(),
            score: this.rating,
            compatibility: this.is_compatible,
            simultaneous_missions: this.other_transports
        };
    }
}
